export default function TypeIcon({ id, naziv }) {
  function getFirst() {
    if (!id && !naziv) return '';
    if (id == '3') return '1';
    if (id == '4') return '2';
    if (id == '5') return '3';
    if (id == '6') return '4';
    if (id == '10') return 'P';
    return naziv?.substring(0, 1).toUpperCase() || '';
  }

  return (
    <div className="icon-container">
      <div className="icon-style">{getFirst()}</div>
    </div>
  );
}
